import { CustomReport } from './report.models';

export class AppRoutes {
  // app routes
  static readonly Book = 'book';
  static readonly BookResults = 'results';
  static readonly BookHotels = 'hotels';
  static readonly GuestDetails = 'guest-details';
  static readonly GuestDetailsGateway = 'reservation';
  static readonly Rooms = 'rooms';
  static readonly BookResultsUrl = `${AppRoutes.Book}/results`;
  static readonly BookHotelsUrl = `${AppRoutes.Book}/${AppRoutes.BookHotels}`;
  static readonly BookConfirmation = `${AppRoutes.Book}/confirmation`;
  static readonly RoomSelectUrlPattern = `${AppRoutes.BookHotelsUrl}/[0-9]+/${AppRoutes.Rooms}`;
  static readonly GuestDetailsUrlPattern = `${AppRoutes.BookHotelsUrl}/[0-9]+/${AppRoutes.GuestDetails}`;
  static readonly ApprovalRequestUrlPattern = `${AppRoutes.Book}/approval-request/`;

  // account routes
  static readonly Account = 'account';
  static readonly Bookings = `${AppRoutes.Account}/bookings`;
  static readonly CompanyPayment = `${AppRoutes.Account}/payment`;
  static readonly CompanyPaymentRemote = `${AppRoutes.Account}/payment-remote`;
  static readonly Reports = `${AppRoutes.Account}/reports`;
  static readonly Reporting = 'reporting';

  //admin routes
  static readonly Admin = 'admin';
  static readonly AdminUsers = `${AppRoutes.Admin}/users`;
  static readonly AdminCustomFields = `${AppRoutes.Admin}/custom-fields`;
  static readonly AdminPayment = `${AppRoutes.Admin}/payment`;

  // analytics routes
  static readonly Analytics = 'analytics';
  static readonly ReportHotels = `${AppRoutes.Analytics}/hotels`;
  static readonly ReportBookers = `${AppRoutes.Analytics}/bookers`;
  static readonly ReportTraveler = `${AppRoutes.Analytics}/traveler`;
  static readonly ReportClientfield = `${AppRoutes.Analytics}/${CustomReport.type}`;
  static readonly ReportDutyofCare = 'workforcetracker';

  // RoomexPay portal routes
  static readonly RoomexPay = 'roomexpay';

  // help routes
  static readonly Help = 'help';

  // error routes
  static readonly Error403 = '403';
  static readonly Error404 = '404';
  static readonly Error500 = '500';
}
